<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <h1 class="page-title pull-left">Wind Directions</h1>
        <div class="pull-right">
          <button class="pointer btn btn-lg btn-primary" v-on:click="form.showEdit({})">Create New</button>
        </div>
      </div>
    </div>

    <div class="panel">
      <div class="panel-heading">
        <h3 class="panel-title">All</h3>
      </div>
      <div class="panel-body">
        <div class="col-xs-12 table-responsive">
          <table class="table table-striped table-bordered table-hover table-fixed">
            <thead>
              <tr>
                <th>Direction</th>
                <th width="120"></th>
              </tr>
            </thead>
            <tbody>

            <tr v-for="item in form.list">
              <td>{{ item.attributes.direction }}</td>
              <td>
                <a class="pointer text-primary" v-on:click="form.showEdit({id: item.id})"><i class="fa fa-pencil" style="margin-right: 10px;"></i></a>
                <a class="pointer text-danger" v-on:click="form.destroy(item.id)"><i class="fa fa-times"></i></a>
              </td>
            </tr>


            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" role="dialog" id="edit">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">{{form.modal.title}}</h4>
          </div>
          <div class="modal-body">
            <form @submit.prevent="form.onSubmit({updateStore: true})" @keydown="form.errors.clear($event.target.id)">
              <input type="hidden" name="id" v-model="form.id">
              <div class="form-group" :class="{'has-error': form.errors.has('direction') }">
                <label class="control-label">Direction</label>
                <input type="text" class="form-control" id="direction" v-model="form.data.direction">
                <span class="help-block" v-if="form.errors.has('direction')" v-text="form.errors.get('direction')"></span>
              </div>

              <loading-button :loading="form.loading" class="btn btn-primary" :disabled="form.errors.any()">Save</loading-button>
              <button type="button" class="btn btn-default" data-dismiss="modal">cancel</button>
            </form>
          </div>
          <div class="modal-footer">
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

  </div>
</template>

<script>
  import WindDirectionsService from '@/services/WindDirectionsService';
  import Form from '@/utils/form';
  import LoadingButton from '@/components/loading-button';

  export default {
    name: 'assays',

    components: {
      LoadingButton
    },

    data() {
      return {
        form: new Form(
          WindDirectionsService,
          {
            direction: null
          })
      }
    },

    mounted() {
      this.form.getList();
    }

  }
</script>

<style lang="scss">

</style>